import { render, staticRenderFns } from "./classify_singer.vue?vue&type=template&id=9a5dd77c&scoped=true&"
import script from "./classify_singer.vue?vue&type=script&lang=js&"
export * from "./classify_singer.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./classify_singer.vue?vue&type=style&index=0&id=9a5dd77c&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9a5dd77c",
  "a95e9820"
  
)

export default component.exports